export default {
    settingsCameraManageEditCamera_title: "Editar Cámara",
    settingsCameraManageEditCamera_cameraUpdated: "La cámara se ha actualizado",
    settingsCameraManageEditCamera_errorMessage: "Se ha producido un error al actualizar la cámara",
    settingsCameraManageEditCamera_label: "Etiqueta",
}